import { AHText, Box, Circle, EmployeeAvatar, TouchableBox } from "arkh";
import React from "react";

import { graphql, useFragment } from "react-relay";
import { WidgetEmployeeRoleOverviewListItem_role$key } from "./__generated__/WidgetEmployeeRoleOverviewListItem_role.graphql";

export type WidgetEmployeeRoleOverviewListItemPressData = {
  roleId: string;
  roleName: string;
  teamId: string;
  teamName: string;
  teamColor: string | null;
  employeeIds: string[];
};

export const WidgetEmployeeRoleOverviewListItem = (props: {
  role: WidgetEmployeeRoleOverviewListItem_role$key;
  onPress?(data: WidgetEmployeeRoleOverviewListItemPressData): void;
  isFocused?: boolean;
}) => {
  const role = useFragment(
    graphql`
      fragment WidgetEmployeeRoleOverviewListItem_role on EmployeeRole {
        id
        name
        team {
          id
          name
          color
        }
        employees {
          id
          name
          ...Avatar_employee
        }
      }
    `,
    props.role
  );

  return (
    <TouchableBox
      disabled={!props.onPress}
      onPress={() =>
        props.onPress?.({
          roleId: role.id,
          roleName: role.name,
          teamId: role.team.id,
          teamName: role.team.name,
          teamColor: role.team.color ?? null,
          employeeIds: role.employees.map((e) => e.id),
        })
      }
      spaceHorizontal="small"
      spaceVertical="small"
      color={props.isFocused ? "surface-background-selected" : undefined}
    >
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        <AHText
          type="subtitle"
          color="text-primary"
          numberOfLines={1}
          style={{ flex: 1 }}
        >
          {role.name}
        </AHText>
        <Box
          style={{ flexDirection: "row", alignItems: "center" }}
          spaceLeft="small"
        >
          <AHText
            type="body"
            color="text-secondary"
            numberOfLines={1}
            spaceRight="xsmall"
          >
            {role.team.name}
          </AHText>
          <Circle
            size="dot"
            style={{ backgroundColor: role.team.color ?? "#888" }}
          />
        </Box>
      </Box>
      {role.employees.length > 0 && (
        <Box
          spaceTop="small"
          gap="small"
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {role.employees.map((employee) => (
            <Box
              key={employee.id}
              gap="xxsmall"
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <EmployeeAvatar
                employee={employee}
                size="small"
                style="default"
              />
              <AHText
                type="body"
                color="text-secondary"
                numberOfLines={1}
                spaceLeft="xsmall"
              >
                {employee.name}
              </AHText>
            </Box>
          ))}
        </Box>
      )}
    </TouchableBox>
  );
};
